import * as types from './tasks-simple.types';
import * as constants from './tasks-simple.constants';
import {
  IGoalStatusUpdate,
  ITaskSimple,
  ITaskSimpleCreate,
  ITaskSimpleCreateForm,
  ITaskSimpleUpdate,
  ITaskSimpleUpdateForm,
} from '../../../resource/task-simple/task-simple.types';
import { IBoardList } from '../../../resource/boards/boardList/boardList.types';
import { DropResult } from 'react-beautiful-dnd';
import { IMeetingSimple } from '../../../resource/meeting-simple/meeting-simple.types';
import { IUser } from '../../../resource/user/user.types';
import { IAddAttachmentForm } from '../../../resource/task/task.types';

export const storeTasksSimple = (tasksSimple: types.ISimpleTasks): types.IStoreTaskSimple => ({
  type: constants.STORE_TASK_SIMPLE,
  payload: tasksSimple,
});
export const clearTaskSimple = (): types.IClearTaskSimple => ({
  type: constants.CLEAR_TASK_SIMPLE,
});

export const createTaskSimple = (task: ITaskSimpleCreate) => ({
  type: constants.CREATE_TASK_SIMPLE,
  payload: { task },
});

export const storeCreatedTaskId = (taskId: ITaskSimple['id']): types.IStoreCreatedTaskId => ({
  type: constants.STORE_CREATED_TASK_ID,
  payload: taskId,
});

export const clearCreatedTaskId = (): types.IClearCreatedTaskId => ({
  type: constants.CLEAR_CREATED_TASK_ID,
});
export const createFormTaskSimple = (task: ITaskSimpleCreateForm): types.ICreateFormTaskSimple => ({
  type: constants.CREATE_FORM_TASK_SIMPLE,
  payload: task,
});
export const updateFormTaskSimple = (task: ITaskSimpleUpdateForm): types.IUpdateFormTaskSimple => ({
  type: constants.UPDATE_FORM_TASK_SIMPLE,
  payload: task,
});

export const updateGoalStatus = (taskId: ITaskSimple['id'], task: IGoalStatusUpdate): types.IUpdateGoalAction => ({
  type: constants.UPDATE_GOAL_STATUS,
  payload: {
    id: taskId,
    data: task,
  },
});

export const updateTaskSimple = (taskId: ITaskSimple['id'], task: ITaskSimpleUpdate): types.IUpdateTaskSimple => ({
  type: constants.UPDATE_TASK_SIMPLE,
  payload: {
    id: taskId,
    data: task,
  },
});

export const deleteTaskSimple = (taskId: ITaskSimple['id']): types.IDeleteTaskSimple => ({
  type: constants.DELETE_TASK_SIMPLE,
  payload: taskId,
});

export const saveTaskOrder = (taskIds: ITaskSimple['id'][], taskTypeId: IBoardList['id']): types.ISaveTaskOrder => ({
  type: constants.SAVE_TASK_ORDER,
  payload: {
    taskIds,
    taskTypeId,
  },
});

export const dndTask = (result: DropResult, meetingId: IMeetingSimple['id']): types.IDndTask => ({
  type: constants.DND_TASK,
  payload: {
    result,
    meetingId,
  },
});

export const setupSharedTask = (id: ITaskSimple['id']): types.ISharedTask => ({
  type: constants.GET_SHARED_TASK,
  payload: id,
});

export const addTaskWatcher = (taskId: ITaskSimple['id']): types.IAddTaskWatcher => ({
  type: constants.ADD_WATCHER,
  payload: taskId,
});
export const deleteTaskWatcher = (taskId: ITaskSimple['id']): types.IDeleteTaskWatcher => ({
  type: constants.DELETE_WATCHER,
  payload: taskId,
});

export const addTaskAttachment = (taskId: ITaskSimple['id'], data: IAddAttachmentForm): types.IAddTaskAttachment => ({
  type: constants.ADD_ATTACHMENT,
  payload: {
    id: taskId,
    data,
  },
});

export const storeQi = (qi: types.ISimpleTasks): types.IStoreTaskSimple => ({
  type: constants.STORE_QI,
  payload: qi,
});
export const clearQi = (): types.IClearTaskSimple => ({
  type: constants.CLEAR_QI,
});

export const storeIsFetched = (): types.IStoreIsFetched => ({
  type: constants.STORE_IS_FETCHED,
});

export const clearIsFetched = (): types.IClearIsFetched => ({
  type: constants.CLEAR_IS_FETCHED,
});

export const initializeTaskProps = (taskId: ITaskSimple['id']): types.IInitializeTaskProps => ({
  type: constants.INITIALIZE_TASK_PROPS,
  payload: taskId,
});
export const clearTaskProps = (): types.IClearTaskProps => ({
  type: constants.CLEAR_TASK_PROPS,
});

export const storeWatcher = (id: IUser['id']): types.IStoreWatcher => ({
  type: constants.STORE_WATCHER,
  payload: id,
});
export const clearWatcher = (): types.IClearWatcher => ({
  type: constants.CLEAR_WATCHER,
});
